import React, { useEffect, useState } from 'react';
import {
  Box,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupIcon from '@mui/icons-material/Group';
import DnsIcon from '@mui/icons-material/Dns';
import NewspaperIcon from '@mui/icons-material/Newspaper';

const routes = [
  { label: 'Dashboard', icon: <DashboardIcon />, path: 'dashboard', match: /^\/pentest\/osint\/dashboard\/.+$/ },
  { label: 'Employees', icon: <GroupIcon />, path: 'employees', match: /^\/pentest\/osint\/employees\/.+$/ },
  { label: 'Infrastructure', icon: <DnsIcon />, path: 'infrastructure', match: /^\/pentest\/osint\/infrastructure\/.+$/ },
  { label: 'Media & Social', icon: <NewspaperIcon />, path: 'media', match: /^\/pentest\/osint\/media\/.+$/ },
];

function Nav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(0);
  const pathParts = location.pathname.replace(/\/$/, '').split('/').filter(Boolean);
  const pentestId = pathParts[pathParts.length - 1];

  useEffect(() => {
    const index = routes.findIndex((route) => route.match.test(location.pathname));
    setSelectedTab(index >= 0 ? index : 0);
  }, [location.pathname]);

  const handleTabChange = (_event, newValue) => {
    setSelectedTab(newValue);
    navigate(`/pentest/osint/${routes[newValue].path}/${pentestId}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        p: 2,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        mb: 3,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography variant="h4" fontWeight="bold">
          OSINT
        </Typography>
      </Box>

      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
      >
        {routes.map((route) => (
          <Tab key={route.path} icon={route.icon} label={route.label} />
        ))}
      </Tabs>
    </Box>
  );
}

export default Nav;
